import * as React from "react";
import Stats from "three/examples/jsm/libs/stats.module";
import { useEffect, useRef } from "react";
import { animationFrame$ } from "@messages/xr/AnimationFrame";
import "./PerformanceTab.component.css";
export const PerformanceTab = () => {
    const container = useRef(null);
    const statsList = useRef([]);
    useEffect(() => {
        createStatsPanel(0);
        createStatsPanel(1);
        createStatsPanel(2);
        animationFrame$.onUpdateStatsBeginDelegate.set(() => {
            statsList.current.forEach((s) => { s.begin(); });
        });
        animationFrame$.onUpdateStatsEndDelegate.set(() => {
            statsList.current.forEach((s) => s.end());
        });
        return () => {
            var _a;
            statsList.current = [];
            (_a = container.current) === null || _a === void 0 ? void 0 : _a.replaceChildren();
        };
    }, []);
    const createStatsPanel = (mode) => {
        var _a;
        const stats = new Stats();
        stats.showPanel(mode);
        stats.dom.style.pointerEvents = "none";
        stats.dom.style.position = "static";
        (_a = container.current) === null || _a === void 0 ? void 0 : _a.appendChild(stats.dom);
        statsList.current.push(stats);
    };
    return (React.createElement("div", { className: "performance-tab" },
        React.createElement("h3", null, "THREE.js Stats"),
        React.createElement("div", { className: "performance-stats", ref: container })));
};
